import React, { useMemo, useState } from 'react';
import { FiSearch, FiCheck, FiGlobe } from 'react-icons/fi';
import { COUNTRIES } from '../../../static/region-data';
import { HiOutlineGlobeAlt } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';

const CountryTab = ({ pendingCountry, setPendingCountry }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    return q
      ? COUNTRIES.filter(
          (c) =>
            c.name.toLowerCase().includes(q) ||
            c.code.toLowerCase().includes(q) ||
            c.dial.includes(q),
        )
      : COUNTRIES;
  }, [search]);

  return (
    <div className='flex flex-col gap-3'>
      {/* Search */}
      <div className='flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 focus-within:border-red-600 transition-colors'>
        <FiSearch className='text-gray-500 shrink-0' size={15} />
        <input
          type='text'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('regionLanguage.country.searchPlaceholder')}
          className='bg-transparent outline-none border-none focus:border-none focus:ring-0  text-white placeholder-gray-600 text-sm w-full'
        />
        {search && (
          <button
            onClick={() => setSearch('')}
            className='text-gray-600 hover:text-white text-xs'
          >
            ✕
          </button>
        )}
      </div>

      {/* Grid */}
      <div className='overflow-y-auto max-h-64 pr-1 scrollbar-thin scrollbar-thumb-white/10'>
        {filtered.length === 0 ? (
          <div className='flex flex-col items-center py-8 text-gray-600'>
            <HiOutlineGlobeAlt size={28} className='mb-2 opacity-30' />
            <p className='text-sm'>{t('regionLanguage.country.empty')}</p>
          </div>
        ) : (
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-1.5'>
            {filtered.map((country) => {
              const isSelected = country.code === pendingCountry;
              return (
                <button
                  key={country.code}
                  onClick={() => setPendingCountry(country.code)}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all
                    ${
                      isSelected
                        ? 'bg-red-600/20 border border-red-600/50'
                        : 'bg-white/[0.03] border border-transparent hover:bg-white/8 hover:border-white/15'
                    }`}
                >
                  <ReactCountryFlag countryCode={country.code} svg />

                  <div className='flex-1 min-w-0'>
                    <p
                      className={`text-sm font-medium truncate ${isSelected ? 'text-white' : 'text-gray-300'}`}
                    >
                      {country.name}
                    </p>
                    <p className='text-xs text-gray-600'>
                      {country.dial} · {country.currency}
                    </p>
                  </div>
                  {isSelected && (
                    <FiCheck size={14} className='text-red-500 shrink-0' />
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CountryTab;
